'use client'

import { useCallback, useState } from 'react'

import type { RenderLink } from '@ui/web/utils'

import { Header } from './header'
import { MainTable } from './main-table'

export type ScoreboardType =
  | {
      type: 'challenge'
      from: 'school' | 'admin' | 'web'
      challengeId: string
    }
  | {
      type: 'course'
      from: 'school' | 'web'
      courseId: string
    }

type ScoreboardProps = ScoreboardType & {
  renderLessonLink: RenderLink
  initialLessonIndex?: number
  onLessonIndexChange?: (index: number) => void
}

export function Scoreboard({ renderLessonLink, initialLessonIndex, onLessonIndexChange, ...p }: ScoreboardProps) {
  const [lessonId, setLessonId] = useState<string | null>(null)
  const [lessonType, setLessonType] = useState<string | null>(null)

  const handleLessonChange = useCallback((lessonId: string) => {
    setLessonId(lessonId)
  }, [])

  const handleLessonTypeChange = useCallback((type: string | null) => {
    setLessonType(type)
  }, [])

  return (
    <main className='srd:flex srd:flex-col srd:items-center srd:justify-start'>
      <div className='srd:w-full srd:bg-neutral-black'>
        <Header
          className='srd:w-full srd:max-w-[1440px] srd:mx-auto srd:px-4 srd:pt-10 srd:pb-6 srd:text-neutral-white'
          onLessonChange={handleLessonChange}
          onLessonTypeChange={handleLessonTypeChange}
          onLessonIndexChange={onLessonIndexChange}
          renderLessonLink={renderLessonLink}
          initialLessonIndex={initialLessonIndex}
          {...p}
        />
      </div>

      <MainTable lessonId={lessonId} lessonType={lessonType} {...p} />
    </main>
  )
}
